import { localUrl as appLocalUrl } from '../app-path.js';
import slugify from "slugify";
import geolocationInstructionsModal from "./geolocation-instructions-modal";
import { SearchedStorage } from "./local-storage-functions";
import FavoriteCityService from "./favorite-city-service";
import { trackGeolocationResult } from "./geolocation-metrics";

function buildCityMeta(place) {
  const name = place.cname;
  const uf = LocalStorageHelper.resolveLocationCode(place);
  const label = `${name} - ${uf}`;
  const slug = slugify(String(name)).replaceAll("-", "").toLowerCase();
  const href = appLocalUrl(`/previsao-do-tempo/cidade/${place.cid}/${slug}-${uf.toLowerCase()}`);
  return { name, uf, label, href };
}

function padIndex(position) {
  const numeric = Number(position) || 0;
  return numeric.toString().padStart(2, '0');
}

function createListItem({ label, href }, position, idSufix) {
  const li = document.createElement('li');
  li.className = 'favorites-list-item';

  const a = document.createElement('a');
  a.href = href;
  a.textContent = label;
  const formattedIndex = padIndex(position);
  a.id = `Modal_Locations_Item_${idSufix}-${formattedIndex}`
  a.dataset.id = `Modal_Locations_Item_${idSufix}-${formattedIndex}`

  li.append(a);
  return li;
}

const getIsLocationGranted = async () => {
  const permissionStatus = await navigator.permissions.query({ name: "geolocation" });

  return permissionStatus.state === "granted";
}

const renderDisabledLocationModal = async () => {
  const isLocationGranted = await getIsLocationGranted();

  if (isLocationGranted) return

  await FavoriteCityService.refreshServerFavorites();
  const storedFavorites = FavoriteCityService.getVisibleFavorites()
  const storedRecents = SearchedStorage.get()

  if (storedFavorites?.length) {
    $("#locations-modal-menu-favorite-locations").empty();

    storedFavorites.slice(0, 4).forEach((favorite, index) => {
      const city = buildCityMeta(favorite.city);
      const li = createListItem(city, index + 1, "FavoriteLink")

      $("#locations-modal-menu-favorite-locations").append(li);
    });
  }

  if (storedRecents?.length) {
    $("#locations-modal-menu-recent-locations").empty();

    storedRecents.slice(0, 4).forEach((recent, index) => {
      const city = buildCityMeta(recent.city);
      const li = createListItem(city, index + 1, "RecentLink")

      $("#locations-modal-menu-recent-locations").append(li);
    });
  }
}

const handleMyLocationButton = () => {
  window.dataLayer = window.dataLayer || [];
  const LOCATION_BUTTON_IDS = {
    use: 'Modal_Locations_Button_UseLocation',
    location: 'Modal_Locations_Button_Location'
  };
  const resolveButtonId = async () => {
    try {
      const permission = await navigator.permissions.query({ name: "geolocation" });
      if (permission?.state === "granted") return LOCATION_BUTTON_IDS.location;
    } catch (e) {}
    return LOCATION_BUTTON_IDS.use;
  };

  resolveButtonId().then((id) => {
    $("#locations-modal-menu-use-my-location-button").attr("data-id", id);
  });

  $("#locations-modal-menu-use-my-location-button")
    .off("click.locationsModal")
    .on("click.locationsModal", () => {
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const buttonId = await resolveButtonId();
        const { latitude, longitude } = position.coords;

        $("#locations-modal-menu-use-my-location-button").empty()
        $("#locations-modal-menu-use-my-location-button").attr("disabled", "true")
        $("#locations-modal-menu-use-my-location-button").append('<div class="loading"></div>')

        $.ajax({
          type: 'POST',
          url: appLocalUrl("/json/minha-localizacao"),
          data: {
            latitude: latitude.toFixed(5),
            longitude: longitude.toFixed(5)
          },
          dataType: 'json',
          success: (json) => {
            const locationData = json.data[0]
            const { idcity, city, uf } = locationData

            const href = appLocalUrl(`/previsao-do-tempo/cidade/${idcity}/${slugify(city).replaceAll("-", "").toLowerCase()}-${uf.toLowerCase()}`)
            window.location.href = href

            window.dataLayer.push({
              event: 'click_button',
              id: buttonId,
              button_action: href,
            })

            trackGeolocationResult({
              method: buttonId,
              status: 'granted',
              locationData,
              coords: position.coords
            });
          }
        })
      },
      async () => {
        const buttonId = await resolveButtonId();
        $('#locations-modal').addClass('hidden')

        window.dataLayer.push({
          event: 'click_button',
          id: buttonId,
        })

        trackGeolocationResult({
          method: buttonId,
          status: 'denied'
        });

        geolocationInstructionsModal.open();
      },
      {
        enableHighAccuracy: true,
        maximumAge: 3000,
      }
    )
  })
}

const handleOutsideModalClick = () => {
  $("#locations-modal-outside-button")
    .off("click.locationsModal")
    .on("click.locationsModal", (e) => {
    $('#locations-modal').addClass('hidden');

    window.dataLayer.push({
      event: 'close_element',
      id: 'Modal_Locations'
    })
  });
}

const open = () => {
  $('#locations-modal').removeClass('hidden')

  window.dataLayer.push({
    event: 'open_element',
    id: 'Modal_Locations'
  })
}

const init = () => {
  renderDisabledLocationModal();
  handleMyLocationButton();
  handleOutsideModalClick();
}

const locationsModal = {
  init,
  open,
}

export default locationsModal
